// src/components/guards/DeleteGuardDialog.jsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DeleteGuardDialog = ({ guard, deleting, onCancel, onConfirm }) => {
  if (!guard) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
        onClick={() => !deleting && onCancel()}
      />
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
        <div className="flex items-start gap-3">
          <div className="mt-1 rounded-full bg-rose-50 p-2">
            <AlertTriangle className="h-5 w-5 text-rose-500" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-slate-800">
              Delete Guard
            </h3>
            <p className="mt-1 text-sm text-slate-600">
              Are you sure you want to delete{' '}
              <span className="font-semibold">
                {guard.first_name} {guard.last_name}
              </span>
              ? This will mark the guard as inactive in the system.
            </p>
          </div>
        </div>
        <div className="mt-6 flex items-center justify-end gap-3">
          <button
            type="button"
            disabled={deleting}
            onClick={onCancel}
            className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-medium text-slate-700 transition-all hover:bg-slate-50 disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={deleting}
            onClick={onConfirm}
            className="rounded-lg bg-rose-500 px-4 py-2 text-sm font-semibold text-white transition-all hover:bg-rose-600 disabled:opacity-60"
          >
            {deleting ? 'Deleting...' : 'Yes, Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteGuardDialog;
